import { Box } from '@mui/material'
import styles from './AppsSection.module.scss'
import { APPS_HEIGHT_MAX, APPS_HEIGHT_MIN } from './appsSectionTokens.js'

export function AppsSectionResizeHandle({ resize }) {
  return (
    <Box
      className={styles.resizeHandle}
      role="separator"
      tabIndex={0}
      aria-orientation="horizontal"
      aria-label="Resize apps section height from the bottom border. Use arrow keys to adjust."
      aria-valuemin={APPS_HEIGHT_MIN}
      aria-valuemax={APPS_HEIGHT_MAX}
      aria-valuenow={resize.appsHeightPx}
      onPointerDown={resize.onResizePointerDown}
      onPointerMove={resize.onResizePointerMove}
      onPointerUp={resize.onResizePointerUp}
      onPointerCancel={resize.onResizePointerUp}
      onKeyDown={resize.onResizeKeyDown}
    />
  )
}
